import { render, staticRenderFns } from "./CompraProdutoNaoConfirmadaNoERP.vue?vue&type=template&id=4fd453f4"
import script from "./CompraProdutoNaoConfirmadaNoERP.vue?vue&type=script&setup=true&lang=js"
export * from "./CompraProdutoNaoConfirmadaNoERP.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports